<template>
  <fragment>
    <div class="dropdown-w" v-show="leadsPageData && !leadsPageData.ClientId">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedClientsIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!clients.length"
              @active-change="onDropdownActiveChange" @change="onClientChange($event)">
          <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.ClientPlaceholder`) }} ({{ usedSelectedClientsIds.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="clientsSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="client in clientsFiltered" :key="client.ID" :value="client.ID" aria-role="listitem">
            <b-checkbox size="is-small" :value="isClientSelected(client.ID)" disabled></b-checkbox>
            <span>{{ client.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Client`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="showCommitments">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedCommitmentsIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!commitments.length"
              @active-change="onDropdownActiveChange" @change="onCommitmentsChange($event)">
          <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.ProjectPerformancePlaceholder`) }} ({{ usedSelectedCommitmentsIds.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="commitmentsSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="commitment in commitmentsFiltered" :key="commitment.ID" :value="commitment.ID" aria-role="listitem">
            <b-checkbox size="is-small" :value="isCommitmentSelected(commitment.ID)" disabled></b-checkbox>
            <span>{{ commitment.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.ProjectPerformance`) }}</p>
        </template>
      </b-tooltip>
    </div>
    <div class="dropdown-w" v-show="showChannelMetadataType">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedChannelMetadataTypesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
              @active-change="onDropdownActiveChange" @change="onChannelMetadataTypesChange($event)">
          <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.ChannelMetadataPlaceholder`) }} ({{ usedSelectedChannelMetadataTypesIds.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="channelMetadataTypesSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="channelMetadataType in channelMetadataTypesFiltered" :key="+channelMetadataType.ID" :value="+channelMetadataType.ID"
                aria-role="listitem" class="dropdown-item-with-icon">
            <b-checkbox size="is-small" :value="isChannelMetadataTypeSelected(+channelMetadataType.ID)" disabled :id="'cbChannelMetadataType_' + channelMetadataType.ID"></b-checkbox>
            <span class="icon-w" v-if="getChannelMetadataTypeIconName(channelMetadataType.ID)">
              <img :src="require('@/assets/' + getChannelMetadataTypeIconName(channelMetadataType.ID) + '.png')" />
            </span>
            <span class="text">{{ channelMetadataType.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.ChannelMetadata`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="showChannels">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedChannelsIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!channels.length"
              @active-change="onDropdownActiveChange" @change="onChannelsChange($event)">
          <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.ChannelPlaceholder`) }} ({{ usedSelectedChannelsIds.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="channelsSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="channel in channelsFiltered" :key="channel.ID" :value="channel.ID" :id="'cbChannel_' + channel.ID"
                aria-role="listitem" class="dropdown-item-with-icon">
            <b-checkbox size="is-small" :value="isChannelSelected(channel.ID)" disabled></b-checkbox>
            <span class="icon-w" v-if="getChannelMetadataTypeIconName(channel.ChannelMetadataType)">
              <img :src="require('@/assets/' + getChannelMetadataTypeIconName(channel.ChannelMetadataType) + '.png')" />
            </span>
            <span class="text">{{ channel.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Channel`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedAssetsIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!assets.length"
              @active-change="onDropdownActiveChange" @change="onAssetsChange($event)">
          <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.AssetsFilterPlaceholder`) }} ({{ usedSelectedAssetsIds.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="assetsSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="asset in assetsFiltered" :key="`${asset.AssetId}_${asset.PhoneId}`" :value="asset.AssetId" aria-role="listitem">
            <b-checkbox size="is-small" :value="isAssetSelected(asset.AssetId)" disabled></b-checkbox>
            <span>{{ asset.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Assets`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w ad-titles-wrapper" v-show="showChannels">
      <b-tooltip position="is-bottom" multilined type="is-dark" style="width: 100%;">
        <b-dropdown :value="usedSelectedAdTitles" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!usedSelectedChannelsIds.length || !adTitles.length"
              @active-change="onDropdownActiveChange" @change="onAdTitlesChange($event)">
          <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.AdTitleFilterPlaceholder`) }} ({{ usedSelectedAdTitles.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="adTitlesSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="(adTitle, index) in adTitlesFiltered" :key="index" :value="getAdTitleId(adTitle)" aria-role="listitem">
            <b-checkbox size="is-small" :value="isAdTitleSelected(getAdTitleId(adTitle))" disabled></b-checkbox>
            <span v-html="adTitle.AdTitle"></span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Title`) }}</p>
        </template>
      </b-tooltip>
      <b-tooltip position="is-bottom" multilined type="is-dark" style="left: 1%; right: 1%;">
        <span class="chart-help">
          <icon-base width="16" height="16" view-box="0 0 16 16" icon-name="chart-pie"><icon-question-circle /></icon-base>
        </span>
        <template #content>
          <p>{{ $t("Leads.AdTitlesTooltip") }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedAdGroupsIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes" :disabled="!usedSelectedChannelsIds.length || !adGroups.length"
              @active-change="onDropdownActiveChange" @change="onAdGroupsChange($event)">
          <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.AdGroupsFilterPlaceholder`) }} ({{ usedSelectedAdGroupsIds.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
          </template>
          <b-dropdown-item v-for="adGroup in adGroupsFiltered" :key="adGroup.ID" :value="adGroup.ID" aria-role="listitem">
            <b-checkbox size="is-small" :value="isAdGroupSelected(adGroup.ID)" disabled></b-checkbox>
            <span>{{ adGroup.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Group`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="pageKind == LeadsPageKind.Leads">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedLeadStatusesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
              @active-change="onDropdownActiveChange" @change="onLeadStatusesChange($event)">
          <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.LeadEntryStatus`) }} ({{ usedSelectedLeadStatusesIds.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
          </template>
          <b-dropdown-item v-for="leadStatus in leadStatusesFiltered" :key="leadStatus.ID" :value="leadStatus.ID" aria-role="listitem">
            <b-checkbox size="is-small" :value="isLeadStatusSelected(leadStatus.ID)" disabled></b-checkbox>
            <span>{{ leadStatus.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.LeadStatus`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedCallStatusesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
              @active-change="onDropdownActiveChange">
          <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.LeadType`) }} ({{ usedSelectedCallStatusesIds.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
          </template>
          <b-dropdown-item v-for="callStatus in callStatuses" :key="+callStatus.ID" :value="+callStatus.ID" aria-role="listitem" @click="onCallStatusesChange(+callStatus.ID)">
            <b-checkbox size="is-small" :value="isCallStatusSelected(+callStatus.ID)" disabled></b-checkbox>
            <span>{{ callStatus.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.LeadType`) }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="showTags">
      <b-tooltip position="is-bottom" multilined type="is-dark">          
        <b-dropdown :value="usedSelectedTags" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
              @active-change="onDropdownActiveChange" @change="onTagsChange($event)">
          <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.Tag`) }} ({{ usedSelectedTags.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="tagsSearch" class="search" :placeholder="$t('Leads.Tag')" expanded @keydown.native="onTagKeydown($event)" />
          </b-dropdown-item>
          <b-dropdown-item v-for="tag in tagsFiltered" :key="tag.ID" :value="tag.ID" aria-role="listitem">
            <b-checkbox size="is-small" :value="isTagSelected(tag.ID)" disabled></b-checkbox>
            <span>{{ tag.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Tag`) }}</p>
        </template>
      </b-tooltip>
    </div>


      <div class="dropdown-w" v-show="pageKind">
        <b-tooltip position="is-bottom" multilined type="is-dark">
          <b-dropdown :value="usedSelectedSaleStatusesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
                @active-change="onDropdownActiveChange" @change="onSaleStatusesChange($event)">
            <template #trigger>
                <b-button>
                  <span class="dropdown-trigger-value">{{ $t("Leads.SaleStatus") }} ({{ usedSelectedSaleStatusesIds.length }})</span>
                  <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                </b-button>
            </template>
            <b-dropdown-item v-for="saleStatus in saleStatusesFiltered" :key="+saleStatus.ID" :value="+saleStatus.ID" aria-role="listitem">
              <b-checkbox size="is-small" :value="isSaleStatusSelected(+saleStatus.ID)" disabled></b-checkbox>
              <span>{{ saleStatus.Title }}</span>
            </b-dropdown-item>
          </b-dropdown>
          <template v-slot:content>
            <p>{{ $t("Leads.Tooltips.Filters.SaleStatus") }}</p>
          </template>
        </b-tooltip>
      </div>

      <div class="dropdown-w" v-show="pageKind">
        <b-tooltip position="is-bottom" multilined type="is-dark">
          <b-dropdown
            :value="usedSelectedAdditionalStatusesIds"
            multiple
            scrollable
            aria-role="list"
            class="multiple custom-checkboxes"
            :disabled="!usedSelectedClientsIds.length || !additionalStatuses.length"
            @active-change="onDropdownActiveChange"
            @change="onAdditionalStatusesChange($event)"
          >
            <template #trigger>
                <b-button>
                  <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.AdditionalStatus`) }} ({{ usedSelectedAdditionalStatusesIds.length }})</span>
                  <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                </b-button>
            </template>
            <b-dropdown-item custom aria-role="listitem" class="filter-search">
              <b-input v-model="additionalStatusesSearch" class="search" :placeholder="$t('Search')" expanded />
            </b-dropdown-item>
            <b-dropdown-item v-for="additionalStatus in additionalStatusesFiltered" :key="+additionalStatus.Value" :value="+additionalStatus.Value" aria-role="listitem">
              <b-checkbox size="is-small" :value="isAdditionalStatusSelected(+additionalStatus.Value)" disabled></b-checkbox>
              <span>{{ additionalStatus.Text }}</span>
            </b-dropdown-item>
          </b-dropdown>
          <template v-slot:content>
            <p>{{ $t(`${kindPrefix}.Tooltips.Filters.AdditionalStatus`) }}</p>
          </template>
        </b-tooltip>
      </div>
    
    <div class="dropdown-w" v-show="showPrice">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedPriceType" aria-role="list" class="custom-checkboxes"
              @active-change="onDropdownActiveChange" @change="onPriceTypeChange($event)">
          <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t(`Enums.LeadPriceType.${LeadPriceType[usedSelectedPriceType]}`).toString() }}</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
          </template>
          <b-dropdown-item v-for="priceType in priceTypes" :key="priceType.ID" :value="priceType.ID" aria-role="listitem">
            <b-checkbox size="is-small" :value="isPriceTypeSelected(priceType.ID)" disabled></b-checkbox>
            <span>{{ priceType.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t("Leads.Tooltips.Filters.LeadPriceType") }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w" v-show="showAssignee">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="usedSelectedAssigneesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
              :disabled="!usedSelectedClientsIds.length || !assignees.length"
              @active-change="onDropdownActiveChange" @change="onAssigneesChange($event)">
          <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ $t(`${kindPrefix}.Assignee`) }} ({{ usedSelectedAssigneesIds.length }})</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="assigneesSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="assignee in assigneesFiltered" :key="assignee.SalesmanID" :value="assignee.SalesmanID" aria-role="listitem">
            <b-checkbox size="is-small" :value="isAssigneeSelected(assignee.SalesmanID)" disabled></b-checkbox>
            <span>{{ assignee.SalesmanName }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t(`${kindPrefix}.Tooltips.Filters.Assignee`) }}</p>
        </template>
      </b-tooltip>
    </div>
  </fragment>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import VueCookies from "vue-cookies";
import Fragment from "vue-fragment";
import { AvailableChannelMetadataTypesMode, ChannelMetadataType } from "@/models/campaigns/ChannelMetadataType";
import { ClientProject } from "@/models/ClientProject";
import { LeadsPageKind } from "@/models/LeadsPageKind";
import { LeadsPageViewModel, RefreshGridMode } from "@/models/leads/ContactForm";
import { LeadPermission, LeadPermissionType } from "@/models/leads/LeadPermission";
import { LeadPriceType } from "@/models/leads/LeadPriceType";
import { LeadStatus } from "@/models/leads/LeadStatus";
import { AdTitlesByLeads, Assignee, ChannelMultiselectItem, MultiselectItem, SelectListItem } from "@/models/MultiselectItem";
import { CommonMultiselectPayload } from "@/services/api/ApiService";
import CampaignService from "@/services/CampaignService";
import HelperService from "@/services/HelperService";
import LeadService from "@/services/LeadService";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import IconQuestionCircle from "../icons/IconQuestionCircle.vue";
import i18n from "../../i18n";

Vue.use(Fragment.Plugin);
Vue.use(VueCookies);
const namespace = "leadsModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
    IconQuestionCircle,
  },
})
export default class LeadsFiltersDropdowns extends Vue {
  @Prop({ required: true }) readonly kindPrefix!: string;
  @Prop({ required: true }) readonly pageKind!: LeadsPageKind;


  //#region Vuex getters and actions

  @Getter("adGroups", { namespace }) adGroups!: MultiselectItem[];
  @Getter("adTitles", { namespace }) adTitles!: AdTitlesByLeads[];
  @Getter("additionalStatuses", { namespace }) additionalStatuses!: SelectListItem[];
  @Getter("assets", { namespace }) assets!: ClientProject[];
  @Getter("assignees", { namespace }) assignees!: Assignee[];
  @Getter("channels", { namespace }) channels!: ChannelMultiselectItem[];
  @Getter("clients", { namespace }) clients!: MultiselectItem[];
  @Getter("commitments", { namespace }) commitments!: MultiselectItem[];
  @Getter("leadClientsSelectedAdditionalStatusesIds", { namespace }) leadClientsSelectedAdditionalStatusesIds!: number[];
  @Getter("leadClientsSelectedAdGroupsIds", { namespace }) leadClientsSelectedAdGroupsIds!: string[];
  @Getter("leadClientsSelectedAdTitles", { namespace }) leadClientsSelectedAdTitles!: string[];
  @Getter("leadClientsSelectedAssetsIds", { namespace }) leadClientsSelectedAssetsIds!: string[];
  @Getter("leadClientsSelectedAssigneesIds", { namespace }) leadClientsSelectedAssigneesIds!: number[];
  @Getter("leadClientsSelectedCallStatusesIds", { namespace }) leadClientsSelectedCallStatusesIds!: number[];
  @Getter("leadClientsSelectedChannelMetadataTypesIds", { namespace }) leadClientsSelectedChannelMetadataTypesIds!: number[];
  @Getter("leadClientsSelectedChannelsIds", { namespace }) leadClientsSelectedChannelsIds!: number[];
  @Getter("leadClientsSelectedClientsIds", { namespace }) leadClientsSelectedClientsIds!: number[];
  @Getter("leadClientsSelectedCommitmentsIds", { namespace }) leadClientsSelectedCommitmentsIds!: number[];
  @Getter("leadClientsSelectedFoundMetadataTypesIds", { namespace }) leadClientsSelectedFoundMetadataTypesIds!: number[];
  @Getter("leadClientsSelectedLeadStatusesIds", { namespace }) leadClientsSelectedLeadStatusesIds!: LeadStatus[];
  @Getter("leadClientsSelectedPriceType", { namespace }) leadClientsSelectedPriceType!: string;
  @Getter("leadClientsSelectedSaleStatusesIds", { namespace }) leadClientsSelectedSaleStatusesIds!: LeadStatus[];
  @Getter("leadClientsSelectedTags", { namespace }) leadClientsSelectedTags!: string[];
  @Getter("leadsPageData", { namespace }) leadsPageData!: LeadsPageViewModel;
  @Getter("selectedAdditionalStatusesIds", { namespace }) selectedAdditionalStatusesIds!: number[];
  @Getter("selectedAdGroupsIds", { namespace }) selectedAdGroupsIds!: string[];
  @Getter("selectedAdTitles", { namespace }) selectedAdTitles!: string[];
  @Getter("selectedAssetsIds", { namespace }) selectedAssetsIds!: string[];
  @Getter("selectedAssigneesIds", { namespace }) selectedAssigneesIds!: number[];
  @Getter("selectedCallStatusesIds", { namespace }) selectedCallStatusesIds!: number[];
  @Getter("selectedChannelMetadataTypesIds", { namespace }) selectedChannelMetadataTypesIds!: number[];
  @Getter("selectedChannelsIds", { namespace }) selectedChannelsIds!: number[];
  @Getter("selectedClientsIds", { namespace }) selectedClientsIds!: number[];
  @Getter("selectedCommitmentsIds", { namespace }) selectedCommitmentsIds!: number[];
  @Getter("selectedFoundMetadataTypesIds", { namespace }) selectedFoundMetadataTypesIds!: number[];
  @Getter("selectedLeadStatusesIds", { namespace }) selectedLeadStatusesIds!: LeadStatus[];
  @Getter("selectedPriceType", { namespace }) selectedPriceType!: string;
  @Getter("selectedSaleStatusesIds", { namespace }) selectedSaleStatusesIds!: LeadStatus[];
  @Getter("selectedTags", { namespace }) selectedTags!: string[];
  @Getter("showNotActiveCampaign", { namespace }) showNotActiveCampaign!: boolean;
  @Getter("showNotActiveCampaignClientLeads", { namespace }) showNotActiveCampaignClientLeads!: boolean;
  @Getter("tags", { namespace }) tags!: MultiselectItem[];
  @Action("clearAdditionalStatuses", { namespace }) clearAdditionalStatuses!: () => void;
  @Action("clearCommitments", { namespace }) clearCommitments!: () => void;
  @Action("getAdditionalStatuses", { namespace }) getAdditionalStatuses!: (payload: CommonMultiselectPayload) => Promise<SelectListItem[]>;
  @Action("getAdGroups", { namespace }) getAdGroups!: (payload: CommonMultiselectPayload) => Promise<MultiselectItem[]>;
  @Action("getAdTitles", { namespace }) getAdTitles!: (payload: CommonMultiselectPayload) => Promise<AdTitlesByLeads[]>;
  @Action("getAssets", { namespace }) getAssets!: (payload: CommonMultiselectPayload) => Promise<ClientProject[]>;
  @Action("getAssignees", { namespace }) getAssignees!: (payload: CommonMultiselectPayload) => Promise<Assignee[]>;
  @Action("getChannels", { namespace }) getChannels!: (payload: CommonMultiselectPayload) => Promise<ChannelMultiselectItem[]>;
  @Action("getCommitments", { namespace }) getCommitments!: (payload: CommonMultiselectPayload) => Promise<MultiselectItem[]>;
  @Action("getTags", { namespace }) getTags!: (payload: CommonMultiselectPayload) => Promise<MultiselectItem[]>;
  @Action("setAssets", { namespace }) setAssets!: (assets: ClientProject[]) => void;
  @Action("setAssignees", { namespace }) setAssignees!: (assignees: Assignee[]) => void;
  @Action("setLeadClientsSelectedAdditionalStatusesIds", { namespace }) setLeadClientsSelectedAdditionalStatusesIds!: (selectedAdditionalStatusesIds: number[]) => void;
  @Action("setLeadClientsSelectedAdGroupsIds", { namespace }) setLeadClientsSelectedAdGroupsIds!: (selectedAdGroupsIds: string[]) => void;
  @Action("setLeadClientsSelectedAdTitles", { namespace }) setLeadClientsSelectedAdTitles!: (selectedAdTitles: string[]) => void;
  @Action("setLeadClientsSelectedAssetsIds", { namespace }) setLeadClientsSelectedAssetsIds!: (selectedAssetsIds: string[]) => void;
  @Action("setLeadClientsSelectedAssigneesIds", { namespace }) setLeadClientsSelectedAssigneesIds!: (selectedAssigneesIds: number[]) => void;
  @Action("setLeadClientsSelectedCallStatusesIds", { namespace }) setLeadClientsSelectedCallStatusesIds!: (selectedCallStatusesIds: number[]) => void;
  @Action("setLeadClientsSelectedChannelsIds", { namespace }) setLeadClientsSelectedChannelsIds!: (selectedChannelsIds: number[]) => void;
  @Action("setLeadClientsSelectedChannelMetadataTypesIds", { namespace }) setLeadClientsSelectedChannelMetadataTypesIds!: (selectedChannelMetadataTypesIds: number[]) => void;
  @Action("setLeadClientsSelectedClientsIds", { namespace }) setLeadClientsSelectedClientsIds!: (selectedClientsIds: number[]) => void;
  @Action("setLeadClientsSelectedCommitmentsIds", { namespace }) setLeadClientsSelectedCommitmentsIds!: (selectedCommitmentsIds: number[]) => void;
  @Action("setLeadClientsSelectedLeadStatusesIds", { namespace }) setLeadClientsSelectedLeadStatusesIds!: (selectedLeadStatusesIds: LeadStatus[]) => void;
  @Action("setLeadClientsSelectedPriceType", { namespace }) setLeadClientsSelectedPriceType!: (selectedPriceType: string) => void;
  @Action("setLeadClientsSelectedSaleStatusesIds", { namespace }) setLeadClientsSelectedSaleStatusesIds!: (selectedSaleStatusesIds: LeadStatus[]) => void;
  @Action("setLeadClientsSelectedTags", { namespace }) setLeadClientsSelectedTags!: (selectedTags: string[]) => void;
  @Action("setNeedToRefreshLeadsGrid", { namespace }) setNeedToRefreshLeadsGrid!: (needToRefreshLeadsGrid: RefreshGridMode) => void;
  @Action("setSelectedAdditionalStatusesIds", { namespace }) setSelectedAdditionalStatusesIds!: (selectedAdditionalStatusesIds: number[]) => void;
  @Action("setSelectedAdGroupsIds", { namespace }) setSelectedAdGroupsIds!: (selectedAdGroupsIds: string[]) => void;
  @Action("setSelectedAdTitles", { namespace }) setSelectedAdTitles!: (selectedAdTitles: string[]) => void;
  @Action("setSelectedAssetsIds", { namespace }) setSelectedAssetsIds!: (selectedAssetsIds: string[]) => void;
  @Action("setSelectedAssigneesIds", { namespace }) setSelectedAssigneesIds!: (selectedAssigneesIds: number[]) => void;
  @Action("setSelectedCallStatusesIds", { namespace }) setSelectedCallStatusesIds!: (selectedCallStatusesIds: number[]) => void;
  @Action("setSelectedChannelMetadataTypesIds", { namespace }) setSelectedChannelMetadataTypesIds!: (selectedChannelMetadataTypesIds: number[]) => void;
  @Action("setSelectedChannelsIds", { namespace }) setSelectedChannelsIds!: (selectedChannelsIds: number[]) => void;
  @Action("setSelectedClientsIds", { namespace }) setSelectedClientsIds!: (selectedClientsIds: number[]) => void;
  @Action("setSelectedCommitmentsIds", { namespace }) setSelectedCommitmentsIds!: (selectedCommitmentsIds: number[]) => void;
  @Action("setSelectedLeadStatusesIds", { namespace }) setSelectedLeadStatusesIds!: (selectedLeadStatusesIds: LeadStatus[]) => void;
  @Action("setSelectedPriceType", { namespace }) setSelectedPriceType!: (selectedPriceType: string) => void;
  @Action("setSelectedSaleStatusesIds", { namespace }) setSelectedSaleStatusesIds!: (selectedSaleStatusesIds: LeadStatus[]) => void;
  @Action("setSelectedTags", { namespace }) setSelectedTags!: (selectedTags: string[]) => void;
  @Action("setTags", { namespace }) setTags!: (tags: MultiselectItem[]) => void;

  //#endregion Vuex getters and actions


  //#region Properties

  LeadsPageKind = LeadsPageKind;
  LeadPriceType = LeadPriceType;

  adGroupsSearch = "";
  adTitlesSearch = "";
  additionalStatusesSearch = "";
  assetsSearch = "";
  assigneesSearch = "";
  channelMetadataTypesSearch = "";
  channelsSearch = "";
  clientsSearch = "";
  commitmentsSearch = "";
  leadStatusesSearch = "";
  saleStatusesSearch = "";
  tagsSearch = "";

  //#endregion Properties


  //#region Watchers

  @Watch("pageKind", { immediate: true })
  onPageKindChange(newValue: LeadsPageKind, oldValue: LeadsPageKind): void {
    if (oldValue === undefined) return;
    if (newValue === undefined) return;

    if (this.usedSelectedClientsIds.length > 0) {
      this.getChannels(this.commonPayload);
    }
  }

  @Watch("leadClientsSelectedAdditionalStatusesIds", { immediate: true })
  @Watch("selectedAdditionalStatusesIds", { immediate: true })
  onSelectedAdditionalStatusesIdsChange(newSelectedAdditionalStatusesIds: number[], oldSelectedAdditionalStatusesIds: number[]): void {
    if (oldSelectedAdditionalStatusesIds === undefined || newSelectedAdditionalStatusesIds.length === oldSelectedAdditionalStatusesIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedAdGroupsIds", { immediate: true })
  @Watch("selectedAdGroupsIds", { immediate: true })
  onSelectedAdGroupsIdsChange(newSelectedAdGroupsIds: string[], oldSelectedAdGroupsIds: string[]): void {
    if (oldSelectedAdGroupsIds === undefined || newSelectedAdGroupsIds.length === oldSelectedAdGroupsIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedAdTitles", { immediate: true })
  @Watch("selectedAdTitles", { immediate: true })
  onSelectedAdTitlesChange(newSelectedAdTitles: string[], oldSelectedAdTitles: string[]): void {
    if (oldSelectedAdTitles === undefined || newSelectedAdTitles.length === oldSelectedAdTitles.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedAssetsIds", { immediate: true })
  @Watch("selectedAssetsIds", { immediate: true })
  onSelectedAssetsIdsChange(newSelectedAssetsIds: string[], oldSelectedAssetsIds: string[]): void {
    if (oldSelectedAssetsIds === undefined || newSelectedAssetsIds.length === oldSelectedAssetsIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedAssigneesIds", { immediate: true })
  @Watch("selectedAssigneesIds", { immediate: true })
  onSelectedAssigneesIdsChange(newSelectedAssigneesIds: number[], oldSelectedAssigneesIds: number[]): void {
    if (oldSelectedAssigneesIds === undefined || newSelectedAssigneesIds.length === oldSelectedAssigneesIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedCallStatusesIds", { immediate: true })
  @Watch("selectedCallStatusesIds", { immediate: true })
  onSelectedCallStatusesIdsChange(newSelectedCallStatusesIds: number[], oldSelectedCallStatusesIds: number[]): void {
    if (oldSelectedCallStatusesIds === undefined || newSelectedCallStatusesIds.length === oldSelectedCallStatusesIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedChannelMetadataTypesIds", { immediate: true })
  @Watch("selectedChannelMetadataTypesIds", { immediate: true })
  onSelectedChannelMetadataTypesIdsChange(newSelectedChannelMetadataTypesIds: number[], oldSelectedChannelMetadataTypesIds: number[]): void {
    if (oldSelectedChannelMetadataTypesIds === undefined || newSelectedChannelMetadataTypesIds.length === oldSelectedChannelMetadataTypesIds.length) {
      return;
    } else {
      if (this.usedSelectedClientsIds.length > 0) {
        this.getChannels(this.commonPayload);
      }
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedChannelsIds", { immediate: true })
  @Watch("selectedChannelsIds", { immediate: true })
  onSelectedChannelsIdsChange(newSelectedChannelsIds: number[], oldSelectedChannelsIds: number[]): void {
    if (oldSelectedChannelsIds === undefined || newSelectedChannelsIds.length === oldSelectedChannelsIds.length) {
      return;
    } else {
      this.getAdTitles(this.commonPayload).then((adTitles: AdTitlesByLeads[]) => {
        if (this.$route.query.adGroups) {
          this.setUsedSelectedAdGroupsIds((this.$route.query.adGroups as string).split(","));
        }
        if (this.$route.query.adTitles) {
          this.setUsedSelectedAdTitles((this.$route.query.adTitles as string).split(","));
        }
      });
      this.getAdGroups(this.commonPayload);
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedClientsIds", { immediate: true })
  @Watch("selectedClientsIds", { immediate: true })
  onSelectedClientsIdsChange(newSelectedClientsIds: number[], oldSelectedClientsIds: number[]): void {
    if (oldSelectedClientsIds === undefined) {
      return;
    } else {
      this.setUsedSelectedChannelsIds([]);
      if (this.usedSelectedClientsIds.length > 0) {
        this.getChannels(this.commonPayload);
      }
      this.setUsedSelectedAssetsIds([]);
      if (newSelectedClientsIds.length > 0) {
        this.getAssets(this.commonPayload).then((assets: ClientProject[]) => {
          if (this.$route.query.assetIds) {
            this.setUsedSelectedAssetsIds((this.$route.query.assetIds as string).split(","));
          }
        });
        this.getAssignees(this.commonPayload).then((assignees: Assignee[]) => {
          if (this.$route.query.assignees) {
            this.setUsedSelectedAssigneesIds((this.$route.query.assignees as string).split(",").map(i => +i));
          }
        });
      } else {
        this.setUsedSelectedAssetsIds([]);
        this.setAssets([]);
        this.setUsedSelectedAssigneesIds([]);
        this.setAssignees([]);
      }
      this.setUsedSelectedCommitmentsIds([]);
      this.getCommitments(this.commonPayload);
      this.setUsedSelectedAdditionalStatusesIds([]);
      this.clearAdditionalStatuses();
      this.getAdditionalStatuses(this.commonPayload).then((statuses: SelectListItem[]) => {
        if (this.$route.query.additionalStatuses) {
          this.setUsedSelectedAdditionalStatusesIds((this.$route.query.additionalStatuses as string).split(",").map(i => +i));
        }
      });
      this.getTags(this.commonPayload);
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedCommitmentsIds", { immediate: true })
  @Watch("selectedCommitmentsIds", { immediate: true })
  onSelectedCommitmentsIdsChange(newSelectedCommitmentsIds: number[], oldSelectedCommitmentsIds: number[]): void {
    if (oldSelectedCommitmentsIds === undefined || newSelectedCommitmentsIds.length === oldSelectedCommitmentsIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedFoundMetadataTypesIds", { immediate: true })
  @Watch("selectedFoundMetadataTypesIds", { immediate: true })
  onSelectedFoundMetadataTypesIdsChange(newSelectedFoundMetadataTypesIds: number[], oldSelectedFoundMetadataTypesIds: number[]): void {
    if (oldSelectedFoundMetadataTypesIds === undefined || newSelectedFoundMetadataTypesIds.length === oldSelectedFoundMetadataTypesIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedLeadStatusesIds", { immediate: true })
  @Watch("selectedLeadStatusesIds", { immediate: true })
  onSelectedLeadStatusesIdsChange(newSelectedLeadStatusesIds: LeadStatus[], oldSelectedLeadStatusesIds: LeadStatus[]): void {
    if (oldSelectedLeadStatusesIds === undefined || newSelectedLeadStatusesIds.length === oldSelectedLeadStatusesIds.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedPriceType", { immediate: true })
  @Watch("selectedPriceType", { immediate: true })
  onSelectedPriceTypeChange(newValue: string, oldValue: string): void {
    if (newValue === oldValue || oldValue === undefined) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedSaleStatusesIds", { immediate: true })
  @Watch("selectedSaleStatusesIds", { immediate: true })
  onSelectedSaleStatusesIdsChange(newSelectedSaleStatusesIds: LeadStatus[], oldSelectedSaleStatusesIds: LeadStatus[]): void {
    if (oldSelectedSaleStatusesIds === undefined || newSelectedSaleStatusesIds.length === oldSelectedSaleStatusesIds.length) {
      return;
    } else {
      this.setUsedSelectedAdditionalStatusesIds([]);
      this.clearAdditionalStatuses();
      this.getAdditionalStatuses(this.commonPayload);
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("leadClientsSelectedTags", { immediate: true })
  @Watch("selectedTags", { immediate: true })
  onSelectedTagsChange(newSelectedTags: string[], oldSelectedTags: string[]): void {
    if (oldSelectedTags === undefined || newSelectedTags.length === oldSelectedTags.length) {
      return;
    } else {
      this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
    }
  }

  @Watch("showNotActiveCampaign", { immediate: true })
  @Watch("showNotActiveCampaignClientLeads", { immediate: true })
  onShowNotActiveCampaignChange(newShowNotActiveCampaignValue: string, oldShowNotActiveCampaignValue: string): void {
    if (newShowNotActiveCampaignValue === oldShowNotActiveCampaignValue || oldShowNotActiveCampaignValue === undefined) {
      return;
    } else {
      if (this.usedSelectedClientsIds.length > 0) {
        this.getChannels(this.commonPayload).then((channels: ChannelMultiselectItem[]) => {
          if (!newShowNotActiveCampaignValue) {
            // filter out selected not active channel channels that not in the new active channels
            const channelsIds: number[] = channels.map(i => parseInt(i.ID));
            const selectedChannelsIdsFiltered: number[] = this.usedSelectedChannelsIds.filter((selectedChannelId: number) => {
              return channelsIds.indexOf(selectedChannelId) >= 0;
            });
            if (selectedChannelsIdsFiltered.length < this.usedSelectedChannelsIds.length) {
              this.setUsedSelectedChannelsIds(selectedChannelsIdsFiltered);
              this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
            }

            this.getAdTitles(this.commonPayload);
            this.getAdGroups(this.commonPayload);
            this.setNeedToRefreshLeadsGrid(RefreshGridMode.Full);
          }
        });
      }
      this.setUsedSelectedCommitmentsIds([]);
      this.clearCommitments();
      this.getCommitments(this.commonPayload);
    }
  }

  //#endregion Watchers


  //#region Getters

  get adGroupsFiltered(): MultiselectItem[] {
    return this.adGroups.filter((i: MultiselectItem) => i.Title?.toLowerCase().indexOf(this.adGroupsSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortMultiselectItems(this.usedSelectedAdGroupsIds));
  }

  get adTitlesFiltered(): AdTitlesByLeads[] {
    return this.adTitles.filter((i: AdTitlesByLeads) => i.AdTitle?.toLowerCase().indexOf(this.adTitlesSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortAdTitles(this.usedSelectedAdTitles));
  }

  get additionalStatusesFiltered(): SelectListItem[] {
    return this.additionalStatuses.filter((i: SelectListItem) => i.Text?.toLowerCase().indexOf(this.additionalStatusesSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortSelectListItems(this.usedSelectedAdditionalStatusesIds));
  }

  get assetsFiltered(): ClientProject[] {
    return this.assets.filter((i: ClientProject) => i.Title?.toLowerCase().indexOf(this.assetsSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortAssets(this.usedSelectedAssetsIds));
  }

  get assigneesFiltered(): Assignee[] {
    return this.assignees.filter((i: Assignee) => i.SalesmanName?.toLowerCase().indexOf(this.assigneesSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortAssignees(this.usedSelectedAssigneesIds));
  }

  get callStatuses(): MultiselectItem[] {
    return LeadService.getCallStatuses();
  }

  get channelMetadataTypesFiltered(): MultiselectItem[] {
    return CampaignService.getChannelMetadataTypes(AvailableChannelMetadataTypesMode.Leads, this.channelMetadataTypesSearch.toLowerCase())
      .sort(HelperService.sortMultiselectItemsByIds(this.usedSelectedChannelMetadataTypesIds));
  }

  get channelsFiltered(): ChannelMultiselectItem[] {
    return this.channels.filter((i: ChannelMultiselectItem) => i.Title?.toLowerCase().indexOf(this.channelsSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortMultiselectItemsByIds(this.usedSelectedChannelsIds));
  }

  get clientsFiltered(): MultiselectItem[] {
    return this.clients.filter((i: MultiselectItem) => i.Title?.toLowerCase().indexOf(this.clientsSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortMultiselectItemsByIds(this.usedSelectedClientsIds));
  }

  get commitmentsFiltered(): MultiselectItem[] {
    return this.commitments.filter((i: MultiselectItem) => i.Title?.toLowerCase().indexOf(this.commitmentsSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortMultiselectItemsByIds(this.usedSelectedCommitmentsIds));
  }

  get commonPayload(): CommonMultiselectPayload {
      let showNotActiveCamp = this.showNotActiveCampaign;
      if (this.pageKind == LeadsPageKind.LeadClients) {
          showNotActiveCamp = this.showNotActiveCampaignClientLeads;
      }

      return {
          clientIds: this.usedSelectedClientsIds,
          showNotActiveCamp: showNotActiveCamp,
          metadataIds: this.usedSelectedChannelMetadataTypesIds,
          statusIds: this.usedSelectedSaleStatusesIds.map((i: LeadStatus) => i.toString()),
          channelIds: this.usedSelectedChannelsIds,
      };
  }

  get leadStatusesFiltered(): MultiselectItem[] {
    return LeadService.getAvailableLeadStatuses(this.leadStatusesSearch.toLowerCase());
  }

  get priceTypes(): MultiselectItem[] {
    const result: MultiselectItem[] = [];
    const keys: number[] = Object.keys(LeadPriceType)
      .filter((i) => parseInt(i) >= 0)
      .map((i) => parseInt(i));
    for (const key of keys) {
      const title: string = i18n.t(`Enums.LeadPriceType.${LeadPriceType[key]}`).toString();
      if (title.toLowerCase().indexOf(this.channelMetadataTypesSearch.toLowerCase()) >= 0) {
        result.push({
          ID: key.toString(),
          Title: title,
        });
      }
    }
    return result;
  }

  get saleStatusesFiltered(): MultiselectItem[] {
    return LeadService.getAvailableSaleStatuses();
  }

  get showAssignee(): boolean {
    return !!this.pageKind && this.leadsPageData && this.leadsPageData.ShowSalesman;
  }

  get showChannels(): boolean {
    return this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: LeadPermission) => i.Restriction === LeadPermissionType.Campaigns);
  }

  get showChannelMetadataType(): boolean {
    return this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: LeadPermission) => i.Restriction === LeadPermissionType.Source);
  }

  get showCommitments(): boolean {
    return this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: LeadPermission) => i.Restriction === LeadPermissionType.Commitment);
  }

  get showGraphsPermission(): boolean {
    return this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: LeadPermission) => i.Restriction === LeadPermissionType.LeadsScreenCharts);
  }

  get showPrice(): boolean {
    return !this.pageKind && this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: LeadPermission) => i.Restriction === LeadPermissionType.Price);
  }

  get showTags(): boolean {
    return this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: LeadPermission) => i.Restriction === LeadPermissionType.Tags);
  }

  get tagsFiltered(): MultiselectItem[] {
    return this.tags.filter((i: MultiselectItem) => !this.tagsSearch || i.Title?.toLowerCase().indexOf(this.tagsSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortMultiselectItems(this.usedSelectedTags));
  }

  //#region Getters based on page kind

  get usedSelectedAdditionalStatusesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedAdditionalStatusesIds;
      case LeadsPageKind.Leads:
        return this.selectedAdditionalStatusesIds;
    }
  }

  get usedSelectedAdGroupsIds(): string[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedAdGroupsIds;
      case LeadsPageKind.Leads:
        return this.selectedAdGroupsIds;
    }
  }

  get usedSelectedAdTitles(): string[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedAdTitles;
      case LeadsPageKind.Leads:
        return this.selectedAdTitles;
    }
  }

  get usedSelectedAssetsIds(): string[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedAssetsIds;
      case LeadsPageKind.Leads:
        return this.selectedAssetsIds;
    }
  }

  get usedSelectedAssigneesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedAssigneesIds;
      case LeadsPageKind.Leads:
        return this.selectedAssigneesIds;
    }
  }

  get usedSelectedCallStatusesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedCallStatusesIds;
      case LeadsPageKind.Leads:
        return this.selectedCallStatusesIds;
    }
  }

  get usedSelectedChannelMetadataTypesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedChannelMetadataTypesIds;
      case LeadsPageKind.Leads:
        return this.selectedChannelMetadataTypesIds;
    }
  }

  get usedSelectedChannelsIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedChannelsIds;
      case LeadsPageKind.Leads:
        return this.selectedChannelsIds;
    }
  }

  get usedSelectedClientsIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedClientsIds;
      case LeadsPageKind.Leads:
        return this.selectedClientsIds;
    }
  }

  get usedSelectedCommitmentsIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedCommitmentsIds;
      case LeadsPageKind.Leads:
        return this.selectedCommitmentsIds;
    }
  }

  get usedSelectedFoundMetadataTypesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedFoundMetadataTypesIds;
      case LeadsPageKind.Leads:
        return this.selectedFoundMetadataTypesIds;
    }
  }

  get usedSelectedLeadStatusesIds(): LeadStatus[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedLeadStatusesIds;
      case LeadsPageKind.Leads:
        return this.selectedLeadStatusesIds;
    }
  }

  get usedSelectedPriceType(): string {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedPriceType;
      case LeadsPageKind.Leads:
        return this.selectedPriceType;
    }
  }

  get usedSelectedSaleStatusesIds(): LeadStatus[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedSaleStatusesIds;
      case LeadsPageKind.Leads:
        return this.selectedSaleStatusesIds;
    }
  }

  get usedSelectedTags(): string[] {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        return this.leadClientsSelectedTags;
      case LeadsPageKind.Leads:
        return this.selectedTags;
    }
  }

  //#endregion Getters based on page kind

  //#endregion Getters


  //#region Handlers

  onAdGroupsChange(adGroups: string[]): void {
    this.setUsedSelectedAdGroupsIds(adGroups);
  }

  onAdTitlesChange(adTitles: string[]): void {
    this.setUsedSelectedAdTitles(adTitles);
  }

  onAdditionalStatusesChange(additionalStatusesIds: number[]): void {
    this.setUsedSelectedAdditionalStatusesIds(additionalStatusesIds);
  }

  onAssetsChange(assetsIds: string[]): void {
    this.setUsedSelectedAssetsIds(assetsIds);
  }

  onAssigneesChange(assigneesIds: number[]): void {
    this.setUsedSelectedAssigneesIds(assigneesIds);
  }

  onCallStatusesChange(selectedValue: number): void {
    // only if user select new value, not if deselect value
    const allCallsValue = -1;
    const enumValues = [0, 1];
    selectedValue = +selectedValue;
    let values = [...this.usedSelectedCallStatusesIds];
    if (values.indexOf(selectedValue) >= 0) {
      const ind: number = values.indexOf(selectedValue);
      values.splice(ind, 1);
    } else {
      values.push(selectedValue);
      if (selectedValue === allCallsValue) {
        // if user picked 'all calls' remove all enum values
        values = values.filter((i: number) => i < 0);
      } else if (enumValues.indexOf(selectedValue) !== -1) {
        // if user picked one value of enum values,
        // remove 'all calls' if not all enum values picked
        // else - replace enum values with 'all calls'
        let i = 0;
        for (let v of enumValues) {
          if (values.indexOf(v) !== -1) {
            i++;
          }
        }
        if (i === enumValues.length) {
          values = values.filter((i: number) => enumValues.indexOf(i) === -1);
          values.push(allCallsValue);
        } else if (values.indexOf(allCallsValue) !== -1) {
          values = values.filter((i: number) => i !== allCallsValue);
        }
      }
    }
    this.setUsedSelectedCallStatusesIds(values);
  }

  onChannelMetadataTypesChange(channelMetadataTypes: ChannelMetadataType[]): void {
    this.setUsedSelectedChannelMetadataTypesIds(channelMetadataTypes);
  }

  onChannelsChange(channelIds: number[]): void {
    this.setUsedSelectedChannelsIds(channelIds);
  }

  onClientChange(clientIds: number[]): void {
    this.setUsedSelectedClientsIds(clientIds);
  }

  onCommitmentsChange(commitmentsIds: number[]): void {
    this.setUsedSelectedCommitmentsIds(commitmentsIds);
  }

  onDropdownActiveChange(show: boolean) {
    HelperService.onDropdownActiveChange(show);
  }

  onLeadStatusesChange(leadStatuses: LeadStatus[]): void {
    this.setUsedSelectedLeadStatusesIds(leadStatuses);
  }

  onPriceTypeChange(priceTypeId: string): void {
    this.setUsedSelectedPriceType(priceTypeId);
  }

  onSaleStatusesChange(saleStatusesIds: string[]): void {
    this.setUsedSelectedSaleStatusesIds(saleStatusesIds.map((i: string) => +i));
  }

  onTagKeydown(e: KeyboardEvent): void {
    if (e.key !== "Enter") {
      return;
    }
    const tag: string = (e.target as HTMLInputElement).value;
    if (tag === "") {
      return;
    }
    var newItem: MultiselectItem = {
      ID: tag,
      Title: tag,
    };
    let newTags = [...this.tags];
    newTags.push(newItem);
    this.setTags(newTags);

    let newSelectedTags = [...this.usedSelectedTags];
    newSelectedTags.push(tag);
    this.onTagsChange(newSelectedTags);
  }

  onTagsChange(tags: string[]): void {
    this.setUsedSelectedTags(tags);
  }

  //#endregion Handlers


  //#region Private methods

  private getAdTitleId(adTitle: AdTitlesByLeads) {
    return HelperService.getAdTitleId(adTitle);
  }

  private getChannelMetadataTypeIconName(type: string): string {
    return CampaignService.getChannelMetadataTypeIconName(+type);
  }

  //#region Is item selected
  
  private isAdditionalStatusSelected(additionalStatusId: number) {
    return this.usedSelectedAdditionalStatusesIds.includes(additionalStatusId);
  }
  
  private isAdGroupSelected(adGroup: string) {
    return this.usedSelectedAdGroupsIds.includes(adGroup);
  }

  private isAdTitleSelected(adTitle: string) {
    return this.usedSelectedAdTitles.includes(adTitle);
  }

  private isAssetSelected(assetId: string) {
    return this.usedSelectedAssetsIds.includes(assetId);
  }
  
  private isAssigneeSelected(assigneeId: number) {
    return this.usedSelectedAssigneesIds.includes(assigneeId);
  }

  private isCallStatusSelected(callStatus: number) {
    return this.usedSelectedCallStatusesIds.includes(callStatus);
  }

  private isChannelSelected(channelId: number) {
    return this.usedSelectedChannelsIds.includes(channelId);
  }

  private isChannelMetadataTypeSelected(channelMetadataTypeId: number) {
    return this.usedSelectedChannelMetadataTypesIds.includes(channelMetadataTypeId);
  }

  private isClientSelected(clientsId: number) {
    return this.usedSelectedClientsIds.includes(clientsId);
  }

  private isCommitmentSelected(commitmentId: number) {
    return this.usedSelectedCommitmentsIds.includes(commitmentId);
  }

  private isLeadStatusSelected(leadStatus: LeadStatus) {
    return this.usedSelectedLeadStatusesIds.includes(leadStatus);
  }
  
  private isPriceTypeSelected(priceType: string) {
    return this.usedSelectedPriceType === priceType;
  }

  private isSaleStatusSelected(leadStatus: LeadStatus) {
    return this.usedSelectedSaleStatusesIds.includes(leadStatus);
  }

  private isTagSelected(tag: string) {
    return this.usedSelectedTags.includes(tag);
  }

  //#endregion Is item selected

  //#region Setters based on page kind

  setUsedSelectedAdditionalStatusesIds(selectedAdditionalStatusesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedAdditionalStatusesIds(selectedAdditionalStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAdditionalStatusesIds(selectedAdditionalStatusesIds);
        break;
    }
  }

  setUsedSelectedAdGroupsIds(sselectedAdGroupsIds: string[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedAdGroupsIds(sselectedAdGroupsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAdGroupsIds(sselectedAdGroupsIds);
        break;
    }
  }

  setUsedSelectedAdTitles(selectedAdTitles: string[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedAdTitles(selectedAdTitles);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAdTitles(selectedAdTitles);
        break;
    }
  }

  setUsedSelectedAssetsIds(selectedAssetsIds: string[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedAssetsIds(selectedAssetsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAssetsIds(selectedAssetsIds);
        break;
    }
  }

  setUsedSelectedAssigneesIds(selectedAssigneesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedAssigneesIds(selectedAssigneesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAssigneesIds(selectedAssigneesIds);
        break;
    }
  }

  setUsedSelectedCallStatusesIds(selectedCallStatusesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedCallStatusesIds(selectedCallStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedCallStatusesIds(selectedCallStatusesIds);
        break;
    }
  }

  setUsedSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIds);
        break;
    }
  }
  
  setUsedSelectedChannelsIds(selectedChannelsIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedChannelsIds(selectedChannelsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedChannelsIds(selectedChannelsIds);
        break;
    }
  }

  setUsedSelectedClientsIds(selectedClientsIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedClientsIds(selectedClientsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedClientsIds(selectedClientsIds);
        break;
    }
  }

  setUsedSelectedCommitmentsIds(selectedCommitmentsIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedCommitmentsIds(selectedCommitmentsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedCommitmentsIds(selectedCommitmentsIds);
        break;
    }
  }

  setUsedSelectedLeadStatusesIds(selectedLeadStatusesIds: LeadStatus[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedLeadStatusesIds(selectedLeadStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedLeadStatusesIds(selectedLeadStatusesIds);
        break;
    }
  }

  setUsedSelectedPriceType(selectedPriceType: string): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedPriceType(selectedPriceType);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedPriceType(selectedPriceType);
        break;
    }
  }

  setUsedSelectedSaleStatusesIds(selectedSaleStatusesIds: LeadStatus[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedSaleStatusesIds(selectedSaleStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedSaleStatusesIds(selectedSaleStatusesIds);
        break;
    }
  }

  setUsedSelectedTags(selectedTags: string[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.LeadClients:
        this.setLeadClientsSelectedTags(selectedTags);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedTags(selectedTags);
        break;
    }
  }

  //#endregion Setters based on page kind

  //#endregion Private methods
}

</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.dropdown-w {
  padding: 0 12px 20px;
  width: 12.5%;
  flex: 0 0 12.5%;

  @media (max-width: 1599px) {
    width: 25%;
    flex: 0 0 25%;

    @media (resolution: 120dpi) {
      width: 12.5%;
      flex: 0 0 12.5%;
    }
  }

  @media (max-width: 1279px) and (resolution: 120dpi) {
    width: 25%;
    flex: 0 0 25%;
  }

  @media (max-width: 991px) {
    width: 50%;
    flex: 0 0 50%;
    padding: 0 8px 15px;
  }

  &.ad-titles-wrapper {
    display: flex;
    .b-tooltip{
      @media (max-width: 991px) {
        display: none;
      }
    }
  }

  

  .b-tooltip {
    color: #aaa;
    margin-right: 0;
    display: block;
  }

  .dropdown {
    width: 100%;

    .dropdown-item-with-icon {
      display: flex;

      .icon-w {
        display: flex;
        margin-inline-end: 0.5rem;
        min-width: 22px;

        img {
          max-height: 22px;
          min-width: 22px;
          width: 22px;
        }
      }
    }

    .dropdown-trigger {
      width: 100%;

      .button {
        width: 100%;
      }
    }
  }
}

html[dir="rtl"] {
  .dropdown-w {
    .b-tooltip {
      margin-left: 0;
      margin-right: .2rem;
    }
  }
}
</style>
